import axios from '../utils/axios';
import config from '../utils/config';

const CHECK_USER_URL = config.get('user_api', 'check_user_url');
const SIGN_UP_URL = config.get('user_api', 'sign_up_url');
const SIGN_IN_URL = config.get('user_api', 'sign_in_url');
const CONFIRM_SIGN_UP_URL = config.get('user_api', 'confirm_sign_up_url');
const RESEND_CONFIRMATION_CODE_URL = config.get('user_api', 'resend_confirmation_code_url');
const FORGOT_PASSWORD_URL = config.get('user_api', 'forgot_password_url');
const CONFIRM_FORGOT_PASSWORD_URL = config.get('user_api', 'confirm_forgot_Password_url');
const VERIFY_SESSION_URL = config.get('user_api', 'verify_session_url');
const REFRESH_SESSION_URL = config.get('user_api', 'refresh_session_url');
const SEND_OTP_URL = config.get('link_accounts', 'send_otp_url');
const VERIFY_OTP_URL = config.get('link_accounts', 'verify_otp_url');
const UPA_SESSION_AUTH = config.get("session", "upa-id")


async function checkUser(username) {
  try {
    const checkUserResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: CHECK_USER_URL,
      data: {
        username,
      },
      headers: { 'Access-Control-Allow-Origin': '*' },
    });
    return checkUserResponse;
  } catch (error) {
    throw error.response;
  }
}

async function signUp(username, password) {
  try {
    const signUpUserResponse = await axios({
      method: 'post',
      url: SIGN_UP_URL,
      data: {
        username,
        password,
      },
    });
    return signUpUserResponse;
  } catch (error) {
    throw error.response;
  }
}

async function confirmSignUp(username, code) {
  try {
    const confirmSignUpUserResponse = await axios({
      method: 'post',
      url: CONFIRM_SIGN_UP_URL,
      data: {
        username,
        code,
      },
    });
    return confirmSignUpUserResponse;
  } catch (error) {
    throw error.response;
  }
}

async function resendConfirmationCode(username) {
  try {
    const resendConfirmationCodeResponse = await axios({
      method: 'post',
      url: RESEND_CONFIRMATION_CODE_URL,
      data: {
        username,
      },
    });
    return resendConfirmationCodeResponse;
  } catch (error) {
    throw error.response;
  }
}

async function signIn(username, password, isSSO, token) {
  try {
    let req = {
      method: 'post',
      url: process.env.REACT_APP_BASE_URL + 'api' + SIGN_IN_URL,
      data: isSSO
        ? { token: token, username }
        : {
            username,
            password,
          },
    };
    if (isSSO) {
      req.headers = { 'x-source': 'sso' };
    }
    const signInUserResponse = await axios(req);
    return signInUserResponse;
  } catch (error) {
    throw error.response;
  }
}

async function forgotPassword(username) {
  try {
    const forgotPasswordResponse = await axios({
      method: 'post',
      url: FORGOT_PASSWORD_URL,
      data: {
        username,
      },
    });
    return forgotPasswordResponse;
  } catch (error) {
    throw error.response;
  }
}

async function confirmForgotPassword(username, newPassword, code) {
  try {
    const confirmForgotPasswordResponse = await axios({
      method: 'post',
      url: CONFIRM_FORGOT_PASSWORD_URL,
      data: {
        username,
        newPassword,
        code,
      },
    });
    return confirmForgotPasswordResponse;
  } catch (error) {
    throw error.response;
  }
}

async function verifySession(username, accessToken, isSSO) {
  try {
    let req = {
      method: 'post',
      url: VERIFY_SESSION_URL,
      data: {
        username,
        accessToken,
      },
    };
    if (isSSO) {
      req.headers = { 'x-source': 'sso' };
    }
    const verifySessionResponse = await axios(req);
    return verifySessionResponse;
  } catch (error) {
    throw error.response;
  }
}

async function refreshSession(username, refreshToken, isSSO) {
  try {
    let req = {
      method: 'post',
      url: REFRESH_SESSION_URL,
      data: {
        username,
        refreshToken,
      },
    };
    if (isSSO) {
      req.headers = { 'x-source': 'sso' };
    }
    const refreshSessionResponse = await axios(req);
    return refreshSessionResponse;
  } catch (error) {
    throw error.response;
  }
}

async function sendOtp(accountToLink, accessToken, username) {
  try {
    const sendOtpResponse = await axios({
      method: 'post',
      url: SEND_OTP_URL,
      data: accountToLink,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return sendOtpResponse;
  } catch (error) {
    throw error.response;
  }
}

async function verifyOTP(accountToLink, otp, accessToken, username) {
  try {
    const verifyOtpResponse = await axios({
      method: 'post',
      url: VERIFY_OTP_URL,
      data: { accountToLink, otp },
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return verifyOtpResponse;
  } catch (error) {
    throw error.response;
  }
}
async function upaSessionAuth(sid){

   try {
    const data = await axios({
      method: "get",
      url: `${UPA_SESSION_AUTH}?sessionId=${sid}`
    });
    return data;
  } catch (error) {
  return error.response
  }
}

export {
  checkUser,
  signUp,
  confirmSignUp,
  resendConfirmationCode,
  signIn,
  forgotPassword,
  confirmForgotPassword,
  refreshSession,
  verifySession,
  sendOtp,
  verifyOTP,
  upaSessionAuth
};
